import React from "react";
import { Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WordsThatTouchTheHeart() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="39797" id="klarheit-bewegung" ref={sectionRef} className="relative min-h-[90vh] w-full overflow-hidden bg-background text-foreground flex items-center py-12 lg:py-0">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0">
        <div className="absolute -left-[10%] -top-[10%] w-[60%] h-[80%] opacity-[0.05] rotate-12">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628971/img/botanical_leaf_watermark.png" alt="" className="w-full h-full object-contain" />
        </div>
        <div className="absolute -right-[5%] bottom-[10%] w-[40%] h-[60%] opacity-[0.03] -rotate-45">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628971/img/botanical_leaf_watermark.png" alt="" className="w-full h-full object-contain" />
        </div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          
          {}
          <div className={`lg:col-span-7 flex flex-col justify-center space-y-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="space-y-8">
              {}
              <span className="inline-block font-default font-light italic text-2xl md:text-3xl text-primary tracking-wide">Praxis Soonwald<br />Dipl.-Psych. Claudia Christ</span>
              {}
              <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl/tight font-light tracking-wider text-foreground">
                Klarheit in der <span className="italic text-primary font-serif">Stille</span>. <br />
                Lösungen in <span className="italic text-primary font-serif">Bewegung</span>.
              </h1>
              {}
              <p className="font-default font-light text-xl text-muted-foreground max-w-2xl leading-relaxed pt-4">Wenn das Leben dich herausfordert, unterstütze ich dich auf deinem Weg zurück zu Klarheit, Perspektive und Stabilität - mit meiner langjährigen Expertise als Diplom-Psychologin und Senior Coach.</p>
            </div>

            <div className="pt-4">
              <Button asChild size="lg" className="rounded-lg px-10 py-7 text-xl shadow-lg hover:shadow-xl transition-all duration-500 bg-primary text-primary-foreground hover:opacity-90">
                <Link to="mailto:post@claudiachrist.de">Gespräch vereinbaren</Link>
              </Button>
            </div>
          </div>

          {}
          <div className={`lg:col-span-5 relative flex justify-center lg:justify-end transition-all duration-1000 delay-300 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            <div className="relative w-full max-w-md lg:max-w-full aspect-[4/5]">
              {}
              <div className="absolute inset-0 overflow-hidden rounded-2xl shadow-xl shadow-muted/50 border-4 border-white/30">
                <img src="https://picked-skylark-1.10web.cloud/wp-content/uploads/2026/04/20200713-SG7_9219-scaled.jpg" alt="Sonnendurchfluteter Soonwald mit Bachlauf" className="w-full h-full object-cover hover:scale-105 transition-transform duration-1000" />
              </div>

              {}
              
            </div>
          </div>

        </div>
      </div>
    </section>;
}